import * as types from '../types';

export const unit: types.Config = Object.freeze({
  locale: 'ja',
  locales: [],
  namespace: []
});
